export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">关于我们</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            了解古古漫画网的故事与使命
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="flex-1">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                古古漫画网成立于2020年，由一群热爱漫画的年轻人创立。我们的初心很简单：打造一个<strong>免费、高清、无广告</strong>的漫画阅读平台，让每一位漫画爱好者都能畅享阅读的乐趣。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                从最初几十部漫画起步，到如今收录<strong>超过10000部</strong>日漫、韩漫、国漫作品，古古漫画网始终坚持<strong>下拉式阅读</strong>的创新体验，成为数百万漫画迷每日必访的漫画大全平台。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                未来，我们将继续拓展漫画资源，优化阅读体验，让更多好看的漫画触手可及。免费漫画在线看全集，尽在古古漫画网。
              </p>
            </div>
            <div className="w-full lg:w-[300px] shrink-0">
              <div className="aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20cozy%20reading%20corner%20with%20a%20tablet%20displaying%20colorful%20manga%20pages%2C%20surrounded%20by%20manga%20volumes%20and%20warm%20ambient%20lighting%2C%20modern%20minimalist%20interior%20with%20wooden%20furniture%2C%20warm%20and%20inviting%20atmosphere%2C%20soft%20natural%20light%20from%20window%2C%20editorial%20photography%20style&width=600&height=450&seq=about-01&orientation=landscape"
                  alt="古古漫画网 - 温馨阅读空间"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-10">
            {[
              { num: '2020年', label: '创立至今' },
              { num: '10000+', label: '漫画资源' },
              { num: '300万+', label: '月活读者' },
              { num: '200+/天', label: '更新话数' },
            ].map((s) => (
              <div key={s.label} className="text-center p-4 rounded-xl border border-background-200/70">
                <div className="text-xl md:text-2xl font-bold text-primary-500 mb-1">{s.num}</div>
                <div className="text-xs text-foreground-500">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}